//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';
import { IUrlRouterProvider } from 'angular-ui-router';

import { creatorsStates } from '@campaigns/routes/creatorsRoutes';
import { samplingStates } from '@campaigns/routes/samplingRoutes';
import { CampaignsStateFactory } from '@campaigns/routes/stateFactory';

import {
  componentNameToTemplate,
  hasFeature,
  lazyLoadModule,
} from 'app/initialization/routing/stateHelpers';

export function routingRules(urlRouterProvider: IUrlRouterProvider) {
  const isCreatorCampaignsEnabled = hasFeature(FeatureNames.CreatorCampaigns);

  if (!isCreatorCampaignsEnabled) {
    urlRouterProvider.when('/campaigns/creators', '/campaigns/sampling');
    urlRouterProvider.when(/\/campaigns\/creators\/.*/, '/campaigns/sampling');
  }
}

export const states = {
  campaigns: CampaignsStateFactory({
    url: '/campaigns',
    template: componentNameToTemplate('campaignsPage'),
    redirectTo: 'campaigns.sampling',
    resolve: {
      ...lazyLoadModule(
        'curalate.campaigns',
        () => import('@campaigns/CampaignsApp'),
      ),
    },
  }),
  ...samplingStates,
  ...creatorsStates,
};
